export default __webpack_public_path__ + "static/media/pool-res3.4bf90878.jpg";